export var Progress;
(function (Progress) {
    Progress["InputTransfer"] = "input_transfer";
    Progress["Refuel"] = "refuel";
    Progress["OutputTransfer"] = "output_transfer";
    Progress["Refund"] = "refund";
})(Progress || (Progress = {}));
export var ProgressStatus;
(function (ProgressStatus) {
    ProgressStatus["Upcoming"] = "upcoming";
    ProgressStatus["Current"] = "current";
    ProgressStatus["Complete"] = "complete";
    ProgressStatus["Failed"] = "failed";
    ProgressStatus["Delayed"] = "delayed";
    ProgressStatus["Removed"] = "removed";
})(ProgressStatus || (ProgressStatus = {}));
